/**
 * 画像ヘルパー関数
 *
 * 共通画像と多言語画像の読み込みを管理する
 *
 * ESLintルールの無効化理由：
 * - import/no-dynamic-require: Webpackが画像ファイルを動的にバンドルするために必要
 * - global-require: 画像パスを実行時に決定する必要があるため
 *
 * 以下の理由により、安全に動的バンドル可能
 * 1. パスが @/assets/images/ 配下に限定
 * 2. try-catchで実行時エラーを適切にハンドリング
 * 3. Webpackのコンテキストモジュールが正しく依存関係を解決
 */

/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */

/**
 * 共通画像を取得 (同期)
 *
 * 言語に依存しない画像を取得する
 *
 * @param {string} imageName - 画像名 (拡張子なし)
 * @param {string} ext - 拡張子
 * @return {string} 画像URL (見つからなかった場合、空文字)
 */
function getCommonImage(imageName, ext = "png") {
  try {
    return require(`@/assets/images/common/${imageName}.${ext}`);
  } catch (error) {
    return "";
  }
}

/**
 * 言語別画像を動的に取得 (非同期)
 *
 * 言語ごとに異なる画像を取得する
 * 必要な言語の画像のみ遅延読み込みする
 *
 * 未対応の言語の場合日本語にフォールバック
 * 日本語が見つからない場合空文字を返却
 *
 * @param {string} imageName - 画像名 (拡張子なし)
 * @param {string} locale - 地域コード (ja, ko, zh-HK, zh-TW, en)
 * @param {string} ext - 拡張子
 * @return {Promise<string>} 画像URL
 */
function getLocalizedImageAsync(imageName, locale, ext = "png") {
  try {
    const image = require(`@/assets/images/${imageName}_${locale}.${ext}`);
    return image.default || image;
  } catch {
    // 日本語にフォールバック
    if (locale !== "ja") {
      try {
        const image = require(`@/assets/images/${imageName}_ja.${ext}`);
        return image.default || image;
      } catch {
        return "";
      }
    }
    return "";
  }
}

export default {
  getCommonImage,
  getLocalizedImageAsync,
};
